export default __webpack_public_path__ + "static/media/fiolet_voice-message.b7109ced.svg";